export const US_COUNTRY_CODE = 'US';
export const CALIFORNIA_REGION_CODE = 'CA';
export const TEXAS_REGION_CODE = 'TX';
export const REGULATED_REGION_CODES = [CALIFORNIA_REGION_CODE, TEXAS_REGION_CODE];
